/* eslint-disable jsx-a11y/no-autofocus */
import PropTypes from "prop-types"
import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import Select, { components } from "react-select"

import downIcon from "../../../../assets/Hub_Icons/downchevron.svg"
import upIcon from "../../../../assets/Hub_Icons/upchevron.svg"

const Dropdown = ({
    placeholder = "",
    defaultValue,
    options,
    changeHandler,
    className,
    name,
    errorData,
    isMulti,
    value,
    disabled,
    isNotRequired,
    isMultiCheckbox,
    chipLimit,
    errorcustomName,
    isAllOption,
    AllSelectLabel,
    isnotSearchable,
    menuPlacement,
    disableErrorMessage,
    isbyDefaultShowAll,
    isUnselectEnabled = false
}) => {
    const isValid = errorData && errorData[name] ? false : true
    const { t } = useTranslation()
    const [focused, setFocused] = useState(false)
    const { ValueContainer, Placeholder } = components
    const allOption = { label: AllSelectLabel, value: "*" }
    const isAllSelected = useRef(false)

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator { ...props }>
                <img
                    alt="dropdown"
                    src={ props.selectProps.menuIsOpen ? upIcon : downIcon }
                    className=""
                    height={ "16px" }
                    width={ "16px" }
                />
            </components.DropdownIndicator>
        )
    }

    const CustomValueContainer = ({ children, hasValue, ...props }) => {

        const PLACEHOLDER_CLASS = `${props.selectProps.isFocused || hasValue
            ? `absolute flex text-sm font-normal text-secondary-50 duration-300 transform -translate-y-[0px] 
            scale-75 left-[-4px] items-center gap-[0px] top-[-33px] bg-white origin-[0] whitespace-nowrap`
            : `absolute flex text-sm font-normal text-secondary-50 duration-300 transform 
            bg-white origin-[0] top-[1px] -translate-y-1/2 scale-100 left-[-8px] pl-3 whitespace-nowrap`
        } `
        return (
            <ValueContainer { ...props }>
                <>
                    <Placeholder { ...props } isFocused={ props.isFocused }>
                        <span className={ PLACEHOLDER_CLASS }>
                            { !isNotRequired && <i className="text-red mr-1">*</i> }
                            { props.selectProps.placeholder }
                        </span>
                    </Placeholder>
                    { (!isMultiCheckbox || !hasValue) &&
                        React.Children.map(children, (child) => {
                            return child && child.key !== "placeholder" ? child : null
                        }) }
                    { isMultiCheckbox &&
                        hasValue &&
                        children &&
                        (() => {
                            let clonedChildren = [...children]
                            const chips_limit = chipLimit || 3
                            const overflowCounter =
                                clonedChildren[0]?.slice(chips_limit).length
                            const displayChips = clonedChildren[0]?.slice(
                                overflowCounter,
                                overflowCounter + chips_limit
                            )
                            clonedChildren[0] = displayChips
                            return (
                                <>
                                    { clonedChildren?.map((intialChild, index) => {
                                        if (index + 1 < clonedChildren.length) {
                                            return intialChild?.map((child) => {
                                                return child && child.key !== "placeholder"
                                                    ? child
                                                    : null
                                            })
                                        } else {
                                            return (
                                                <>
                                                    { overflowCounter > 0 && (
                                                        <div className="text-primary-100 text-sm font-normal">
                                                            { `+ ${overflowCounter}` }</div>
                                                    ) }
                                                    { intialChild && intialChild.key !== "placeholder"
                                                        ? intialChild
                                                        : null }
                                                </>
                                            )
                                        }
                                    }) }
                                </>
                            )
                        })() }
                </>
            </ValueContainer>
        )
    }

    const Input = (props) => {
        if (!props.selectProps.menuIsOpen || props.selectProps.menuIsOpen)
            return (
                <components.Input autoFocus={ props.selectProps.menuIsOpen } { ...props }>
                    { props.children }
                </components.Input>
            )
        else
            return (
                <div style={ { border: "1px dotted gray" } } >
                    <components.Input autoFocus={ props.selectProps.menuIsOpen } { ...props } >
                        { props.children }
                    </components.Input>
                </div>
            )
    }

    const Option = (props) => {
        return (
            <>
                <components.Option { ...props }>
                    <>
                        <div className="flex items-center gap-1">
                            { isMultiCheckbox && (
                                <div className="relative cursor-pointer  select-none w-[18px] h-[18px] custom-checkbox">
                                    <input
                                        className="peer w-[18px] h-[18px] absolute opacity-0 z-[1]"
                                        type="checkbox"
                                        checked={ props.value === "*" ? isAllSelected.current : props.isSelected }
                                        onChange={ () => null }
                                    />
                                    <span
                                        className={ `checkmark absolute h-[18px] w-[18px]  bg-white 
                                            border rounded-[4px] border-primary-50  z-[2]  
                                            after:absolute after:hiddent after:content-[''] 
                                            after:w-[6px] after:h-[12px] after:rotate-45  
                                            after:border-b-[2px]  after:border-r-[2px] 
                                            after:border-white after:left-[5px] after:top-[1px] 
                                            ${props.isSelected || isAllSelected.current 
                                    ? "after:block !bg-primary-50" : ""}` }
                                    ></span>
                                </div>
                            ) }
                            <label>{ props.label }</label>
                        </div>
                    </>
                </components.Option>
            </>
        )
    }

    const customeStyles = {
        indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
        input: (styles) => ({
            ...styles,
            fontSize: "19px",
            lineHeight: "20px",
            padding: "5px 10px 5px 0"
        }),
        option: (styles, state) => ({
            ...styles,
            "&:hover": {
                backgroundColor: "#EDF5FF"
            },
            backgroundColor: state.isSelected ? "#E3ECF9" : state.isFocused
                ? "#F8F9FA" : "#fff",
            color: isMultiCheckbox
                ? "#34383F"
                : state.isDisabled ? "#34383f" : "#000000",
            fontSize: 14
           
        }),
        placeholder: (styles, state) => ({
            ...styles,
            width: "100%",
            color: state.isFocused ? "#34383f" : "#6C6C6C",
            display: "flex",
            alignItems: "center",
            gap: "0px",
            fontSize: 12,
            // marginTop: 11,
            padding: "0px",
            position: "absolute",
            transitionDuration: "300ms",
            transformOrigin: 0,
            transition: state.hasValue ||
                state.selectProps.inputValue ||
                state.selectProps.isFocused ||
                state.selectProps.value
                ? "translateY(0px) scale(.75)"
                : "translateY(50%) scale(1)",
            left: "8px"
            
        }),
        valueContainer: (base) => ({
            ...base,
            overflow: "visible",
            paddingLeft: 10,
            width: "60%",
            display: isMultiCheckbox ? "flex ": "grid "
        }),
        control: (base, state) => ({
            ...base,
            borderRadius: 8,
            fontfamily: "Avenir",
            fontSize: 14,
            height: "100%",
            width: "100%",
            borderColor: state.selectProps.menuIsOpen
                ? "#003DA5"
                : isValid
                    ? "#CED0D6"
                    : "#CE121F",
            boxShadow: null,
            backgroundColor: state.isDisabled
                ? "#F8F9FA"
                : state.selectProps.menuIsOpen
                    ? "#EDF5FF"
                    : "#FFFFFF",
            "&:hover": {
                borderColor: "#003DA5"
            }
        }),
        menu: (styles) => {
            return {
                ...styles,
                zIndex: 6
            }
        },
        singleValue: (styles, { isDisabled }) => {
            return {
                ...styles,
                color: isDisabled ? "#000000" : "#333333",
                fontWeight: 400
            }
        },
        multiValue: (styles) => {
            return {
                ...styles,
                backgroundColor: "#F3F3F3",
                borderColor: "#CED0D6",
                borderRadius: 10,
                maxWidth: chipLimit === 1 ? "55%" : chipLimit === 2 ? "36%" : "18%"
            }
        },
        multiValueLabel: (styles) => ({
            ...styles,
            color: "#3438F"
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: "#002466",
            ":hover": {
                backgroundColor: "#002466",
                color: "#FFFFFF",
                borderRadius: "0px 10px 10px 0px"
            }
        }),
        indicators: (styles) => ({
            ...styles,
            width: "23%"
        })
    }

    const getValue = (value, arr, isMulti) => {
        if (value != undefined && value !== "" && arr !== undefined && arr?.length > 0) {
            if (!isMulti) {
                const selected  = arr.find((obj) => obj.value.toString() == value.toString())
                if (!selected && value) {
                    changeHandler({}, name)
                }
                return selected
            } else {
                let existingValues = value?.split(",")
                existingValues = existingValues.map(function (el) {
                    return el.trim()
                })
                const selectedValues = arr.filter(
                    (item) => existingValues.indexOf(item?.value?.toString()) >= 0
                )
                isAllSelected.current = selectedValues.length === arr.length
                if (selectedValues.length == 0 && value) {
                    changeHandler(selectedValues, name)
                }
                return selectedValues
            }
        } else {
            if (defaultValue && isbyDefaultShowAll) {
                return isMulti ? [{ value: 0, label: defaultValue }] : { value: 0, label: defaultValue }
            }
            return false
        }
    }

    return (
        <>
            <Select
                className={ `${className}` }
                classNamePrefix="select"
                components={ {
                    DropdownIndicator,
                    Input,
                    Option,
                    ValueContainer: CustomValueContainer
                } }
                value={ getValue(value, options, isMulti) }
                styles={ customeStyles }
                placeholder={ placeholder }
                defaultValue={ defaultValue }
                closeMenuOnSelect={ isMulti && isMultiCheckbox ? false : true }
                hideSelectedOptions={ isMulti && isMultiCheckbox ? false : true }
                onFocus={ () => setFocused(true) }
                onBlur={ () => setFocused(false) }
                isSearchable={ !isnotSearchable }
                isFocused={ focused }
                isDisabled={ disabled }
                options={ isAllOption && options?.length > 0 ? [allOption, ...options] : options }
                name={ name }
                isMulti={ isMulti }
                isClearable={ isUnselectEnabled }
                menuPlacement={ menuPlacement }
                openMenuOnClick={ true }
                onChange={ (selectedValue) => {
                    if (
                        isMulti &&
                        selectedValue.length &&
                        selectedValue.find((option) => option.value === "*")
                    ) {
                        if (isAllSelected.current === true) {
                            changeHandler([], name)
                            isAllSelected.current = false
                        } else {
                            changeHandler(options, name)
                            isAllSelected.current = true
                        }
                    } else if (isMulti) {
                        if (selectedValue.length > 0) {
                            changeHandler(selectedValue, name)
                            isAllSelected.current = selectedValue.length === options.length
                        } else {
                            changeHandler([], name)
                            isAllSelected.current = false
                        }
                    } else {
                        changeHandler(selectedValue, name)
                    }
                } }
            />
            { !disableErrorMessage && errorData && errorData[name] && (
                <span className="relative text-red text-xs font-normal font-['Avenir'] leading-[14px]">
                    { errorcustomName ? t(`errorMessage.${errorcustomName}.${name}`) : t(`errorMessage.${name}`) }
                </span>
            ) }
        </>
    )
}

Dropdown.propTypes = {
    AllSelectLabel: PropTypes.string,
    changeHandler: PropTypes.func.isRequired,
    children: PropTypes.node,
    chipLimit: PropTypes.number,
    className: PropTypes.string,
    defaultValue: PropTypes.any,
    disabled: PropTypes.bool,
    errorData: PropTypes.object,
    errorcustomName: PropTypes.string,
    hasValue: PropTypes.bool,
    isAllOption: PropTypes.bool,
    isMulti: PropTypes.bool,
    isMultiCheckbox: PropTypes.bool,
    isNotRequired: PropTypes.bool,
    isSelected: PropTypes.bool,
    menuIsOpen: PropTypes.bool,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    selectProps: PropTypes.object,
    value: PropTypes.any,
    disableErrorMessage: PropTypes.bool
}

export default Dropdown
